var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"nut-banner"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"banner-child"}),_c('h1',[_vm._v("Secretele "),_c('br',{staticClass:"d-block d-md-none"}),_vm._v("laptelui matern "),_c('br',{staticClass:"d-none d-md-block"}),_vm._v(" și beneficiile lui pentru imunitate. ")])])])])
}]

export { render, staticRenderFns }